import type { Components, Theme } from '@mui/material/styles';

import { alertComponents } from './alert';
import { buttonComponents } from './button';
import { cardComponents } from './card';
import { cssBaselineComponents } from './css-baseline';
import { inputComponents } from './inputs';
import { navigationComponents } from './navigation';
import { surfaceComponents } from './surfaces';
import { tableComponents } from './table';

export const components: Components<Theme> = {
    ...cssBaselineComponents,

    ...alertComponents,

    ...buttonComponents,

    ...cardComponents,

    ...inputComponents,

    ...navigationComponents,

    ...surfaceComponents,

    ...tableComponents,
};